// src/hooks/useDoctorsApi.js
import { useCallback } from "react";
import useApi from "./useApi";

/**
 * Custom hook for doctors-related API calls
 */
export const useDoctorsApi = () => {
  const { api, loading, error, data } = useApi({
    showToast: true,
  });

  /**
   * Get all doctors
   */
  const getDoctors = useCallback(async (params = {}) => {
    return await api.get("/doctors/v1/doctors", params, { showToast: false });
  }, [api]);

  /**
   * Get doctor by ID
   * @param {number} doctorId - Doctor ID
   */
  const getDoctorById = async (doctorId) => {
    return await api.get(`/doctors/v1/doctors/${doctorId}`, {
      showToast: true,
    });
  };

  /**
   * Search doctors by specialty or name
   * @param {string} query - Search query
   */
  const searchDoctors = async (query) => {
    return await api.get(`/doctors/v1/doctors?search=${query}`, {
      showToast: false,
    });
  };

  return {
    getDoctors,
    getDoctorById,
    searchDoctors,
    loading,
    error,
    data,
  };
};

export default useDoctorsApi;
